import { getAccountDetails, loadPlans } from 'actions/accountActions';
import AppPageHeader from 'components/common/AppPageHeader';
import PageRow from 'components/common/PageRow';
import getSymbolFromCurrency from 'currency-symbol-map';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import config from '../../helpers/configHelper';
import CardUpdateSection from './components/CardUpdateSection';
import CardModal from './components/card_modal/CardModal';
import Invoices from './components/Invoices';
import SelectedPlansOptionsSection from './components/plans_section/SelectedPlansOptionsSection';

const PageContainer = styled.div`
  width: ${props => (props.editMode ? '100%' : '118.8rem')};
`;

function BillingPage() {
  const dispatch = useDispatch();

  const user = useSelector((state: any) => state.user.current);

  const cardDetails = {};
  const [cardModalVisible, setCardModalVisible] = useState(false);
  const [plans, setPlans] = useState({});
  const [payments, setPayments] = useState([]);
  const [currencySymbol, setCurrencySymbol] = useState('');

  useEffect(() => {
    initData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function initData() {
    let initialPlans: any = await dispatch(loadPlans());

    setPlans(initialPlans);

    const userId = user?.id;

    if (!userId) return;

    let accountDetails: any = await dispatch(getAccountDetails(userId));

    if (!accountDetails) return;

    if (accountDetails.payment_history) setPayments(accountDetails.payment_history);
    if (accountDetails.currency) {
      let symbol = getSymbolFromCurrency(accountDetails.currency);
      if (symbol) setCurrencySymbol(symbol);
    }
  }

  function toggleCardModalVisibility() {
    setCardModalVisible(!cardModalVisible);
  }

  function render() {
    return (
      <PageContainer editMode={cardModalVisible}>
        {cardModalVisible ? (
          <CardModal cardDetails={cardDetails} goBack={toggleCardModalVisibility} />
        ) : (
          <>
            <AppPageHeader title="Billing" />

            <PageRow>
              <SelectedPlansOptionsSection plans={plans} />
              <div>
                <Invoices invoices={payments} currency={currencySymbol} />
                {config.baseUrl.includes('https://api.traveladviceapi.com') ? (
                  ''
                ) : (
                  <div>
                    <CardUpdateSection />
                  </div>
                )}
              </div>
            </PageRow>
          </>
        )}
      </PageContainer>
    );
  }

  return render();
}

export default BillingPage;
